import modelOneApi from "../api/modelOne"

export default {    
    methods: {
        loadDropdownItems(modelType, target) {
            modelOneApi.getAll(modelType, data => {
                target.length = 0
                if (data.ok) {
                    if (data.d.forEach) {
                        data.d.forEach(el => {
                            target.push({ text: el.name, value: el.id })
                        })
                    } else {
                        data.d.items.forEach(el => {
                            target.push({ text: el.name, value: el.id })
                        })
                    }
                }
            })
        },
        loadDropdownItems2(modelType, target, doneCallback) {
            modelOneApi.getAll(modelType, data => {
                target.length = 0
                if (data.ok) {
                    // TODO remove old method
                    if (data.d.forEach) {
                        data.d.forEach(el => {
                            target.push({ text: el.name, value: el })
                        })
                    } else {
                        data.d.items.forEach(el => {
                            target.push({ text: el.name, value: el })
                        })
                    }
                    if (typeof doneCallback == "function") {
                        doneCallback()
                    }
                }
            })
        },
    }
}